import React from "react";
import { testIncomeStatementData } from "./testData";
import { render } from "@testing-library/react";
const data = testIncomeStatementData;

interface Props {
  config: any;
  data: any;
}

const Table = ({ config, data }: Props) => {
  const renderedRows = data.map((company: any) => (
    <tr key={company.cik}>
      {config.map((val: any) => (
        <td key={val.label} className="p-4 whitespace-nowrap text-sm font-normal text-gray-900">
          {val.render(company)}
        </td>
      ))}
    </tr>
  ));

  const renderedHeaders = config.map((config: any) => (
    <th
      key={config.label}
      className="p-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
    >
      {config.label}
    </th>
  ));

  // ensure table will exceed viewport when many columns so wrapper can scroll
  const minColumnWidth = 180; // px per column — adjust as needed
  const tableMinWidth = `${Math.max((config?.length || 0) * minColumnWidth, 600)}px`;

  return (
    <div className="bg-white shadow rounded-lg p-4 sm:p-6 xl:p-8">
      <div className="overflow-x-auto w-full">
        <table style={{ minWidth: tableMinWidth }} className="table-auto divide-y divide-gray-200">
          <thead>
            <tr>{renderedHeaders}</tr>
          </thead>
          <tbody>{renderedRows}</tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
